import Cookie, { JWT_COOKIE_NAME } from "../lib/cookie";

export const useLoggedIn = () => {
  const user = localStorage.getItem("user");
  const token = Cookie.get(JWT_COOKIE_NAME);

  return { user, isLoggedIn: !!token };
};
